import type { RootState } from 'state/modules';

/**
 * @param {Object} state
 * @return {Boolean}
 */
export const isLoading = (state: RootState) => state.lendersByProducts.isLoading;

/**
 * @param {Object} state
 * @return {Array}
 */
export const getResults = (state: RootState) => state.lendersByProducts.lendersByProductsResults;

export const getMeta = (state: RootState) => state.lendersByProducts.meta;

/**
 * @param {Object} state
 * @return {Object|null}
 */
export const getError = (state: RootState) => state.lendersByProducts.error;
